import type { SubtitleTextTransform } from "@/lib/subtitles/subtitleTextTransform";
import { DEFAULT_SUBTITLE_OUTLINE } from "@/lib/subtitles/subtitleOutline";

export const defaultLogoPositions = [
  { value: "top-left", row: 0, col: 0 },
  { value: "top-center", row: 0, col: 1 },
  { value: "top-right", row: 0, col: 2 },
  { value: "center-left", row: 1, col: 0 },
  { value: "center", row: 1, col: 1 },
  { value: "center-right", row: 1, col: 2 },
  { value: "bottom-left", row: 2, col: 0 },
  { value: "bottom-center", row: 2, col: 1 },
  { value: "bottom-right", row: 2, col: 2 },
];

export const defaultSubtitleData = {
  fontFamily: "Roboto",
  fontSize: 50,
  textColor: "#FFFFFF",
  highlightColor: "#CCFF00",
  highlightEnabled: true,
  highlightBoxEnabled: false,
  highlightBoxBackgroundColor: "#FFFFFF",
  highlightBoxBorderRadius: 20,
  highlightBoxPaddingX: 0.2,
  highlightBoxPaddingY: 0.1,
  backgroundColor: "#000000",
  backgroundEnabled: false,
  backgroundOpacity: 80,
  backgroundWidth: 100,
  backgroundHeight: 100,
  position: "bottom-center",
  marginVertical: 30,
  marginHorizontal: 10,
  shadowEnabled: true,
  shadowColor: "#000000",
  shadowSize: 50,
  ...DEFAULT_SUBTITLE_OUTLINE,
  animation: "Fade In",
  textAlign: "center" as "left" | "center" | "right",
  textTransform: "uppercase" as SubtitleTextTransform,
  removePunctuation: false,
  maxWordsPerLine: 6,
};

export const defaultLogoData = {
  url: null as string | null,
  position: "bottom-right",
  size: 20,
  opacity: 70,
  horizontalMargin: 5,
  verticalMargin: 5,
};
